export const BASEURL = `https://starcinemas-api.nuviotech.co/`;
 
export const IMGBASEURL = `https://d1w0nivq15f02e.cloudfront.net`;
 
export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const STAR_UAE = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6Ijg2ZGMxZWZiLTM2ODAtNDBlNS1iYWEzLTg5OGRmNDFlYzYwMiIsImlhdCI6MTczMjM4NjgxMn0.AvILSoBpzRIsQOfaeP3K6zhvM8U-iVYZ6dOw45-R8bk`
export const TOKEN = STAR_UAE



// WEBPACK FOOTER //
// ./src/config/index.js